module.exports = __webpack_public_path__ + "img/26_16.84e3dab6.png";